import * as angular from "angular";
import * as _ from "lodash";
import { Color } from "../utils/interfaces";

export class CanvassStatus {
    public readonly colors: Color[] = [
        { hex: "#ff1b38", alias: "brightred" },
        { hex: "#cb4064", alias: "fadedred" },
        { hex: "#d0021b", alias: "red" },
        { hex: "#cc530f", alias: "burntorange" },
        { hex: "#f97319", alias: "orange" },
        { hex: "#ffab3c", alias: "lightorange" },
        { hex: "#f8ec24", alias: "brightyellow" },
        { hex: "#a3f824", alias: "brightgreen" },
        { hex: "#14b26d", alias: "lightgreen" },
        { hex: "#198c59", alias: "halflightgreen" },
        { hex: "#0a613b", alias: "green" },
        { hex: "#00637f", alias: "teal" },
        { hex: "#0664af", alias: "darkblue" },
        { hex: "#4986E7", alias: "blue" },
        { hex: "#46cbf0", alias: "lightblue" },
        { hex: "#35aacc", alias: "halflightblue" },
        { hex: "#2f3292", alias: "navy" },
        { hex: "#9800ff", alias: "darkpurple" },
        { hex: "#8e68c6", alias: "purple" },
        { hex: "#d954e3", alias: "pinkpurple" },
        { hex: "#ff45da", alias: "brightpink" },
        { hex: "#ff1961", alias: "pink" },
        { hex: "#ff5d92", alias: "fadedpink" },
        { hex: "#F691B3", alias: "lightpink" },
        { hex: "#000000", alias: "black" },
    ];

    public id: string | null = null;
    public name: string | null = null;
    public description: string | null = null;
    public color: string;
    public order: any = null;
    public status = "Active";
    public nbstatus = "other";
    public creator: any = null;
    public lastupdater: any = null;
    public is_nationbuilder: any = null;
    public effortid: any = null;
    public creationdatetime: any = null;
    public lastmodifieddatetime: any = null;
    public count: any;
    public workflow: any;

    constructor(data?: any) {
        this.color = this.randomColor();

        if (data && data.attributes) {
            this.setData(data.attributes);
            this.id = data.id;
        } else if (data) {
            this.setData(data);
        }
    }

    groupByColor(statuses: CanvassStatus[]): CanvassStatus[] {
        let groupedStatuses: CanvassStatus[] = [];
        let found: boolean;
        angular.forEach(statuses, (status) => {
            found = false;
            angular.forEach(groupedStatuses, (groupedStatus) => {
                if (groupedStatus.color === status.color) {
                    found = true;
                    groupedStatus.name =
                        groupedStatus.name + ", " + status.name;
                    groupedStatus.count =
                        parseInt(groupedStatus.count) + parseInt(status.count);
                }
            });
            if (!found) {
                groupedStatuses.push(status);
            }
        });
        return groupedStatuses;
    }

    randomColor(): string {
        let rand = Math.floor(Math.random() * this.colors.length);
        return this.colors[rand].hex;
    }

    getColorAlias(color: string): string {
        for (let i = 0; i < this.colors.length; i++) {
            if (this.colors[i].hex == color) {
                return this.colors[i].alias;
            }
        }
    }

    setData(data: object): void {
        _.merge(this, data);
    }
}
